import React from 'react';
import { Dimensions } from 'react-native';
import Svg, { SvgIconName } from 'components/UI/Svg/Svg';
import { Color } from 'modules/styles/colors';
import { animated, useTrail } from 'react-spring';
import AbsoluteBox from 'components/UI/Layout/AbsoluteBox';

const TRAIL_LENGTH = 25;
const svgList: SvgIconName[] = ['ConnectCare', 'FindProviderIcon', 'TriageIcon'];

const svgArray = Array.from({ length: TRAIL_LENGTH }, (_, i) => svgList[i % svgList.length]);
const AnimatedView = animated(AbsoluteBox);
const { height: screenHeight, width: screenWidth } = Dimensions.get('window');

function LoadingAnimation() {
  const [trail] = useTrail(TRAIL_LENGTH, () => ({
    config: { mass: 20, tension: 280, friction: 320 },
    from: { top: -50, opacity: 1 },
    to: { top: screenHeight + 30, opacity: 0.0 }
  }));

  return (
    <>
      {trail.map((style, i) => {
        const size = Math.floor(30 + Math.random() * 20);
        const svgPosition = 10 + Math.floor(Math.random() * screenWidth * 0.9);
        const key = `${size}-${svgPosition}`;
        return (
          // @ts-ignore animated style doesn't match react-spring styles props
          <AnimatedView style={style} left={svgPosition} key={key}>
            <Svg name={svgArray[i]} height={size} width={size} stroke={Color.foreColor} />
          </AnimatedView>
        );
      })}
    </>
  );
}

export default LoadingAnimation;
